import { render, staticRenderFns } from "./lucroatacado.vue?vue&type=template&id=53795b78"
import script from "./lucroatacado.vue?vue&type=script&lang=js"
export * from "./lucroatacado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports